import React from 'react'

const NoticeMessageContainer = ({ text = '' }) => (
  <div className={`${text ? 'alert alert-notice' : 'hidden'} pdf-hide`}>
    {text}
  </div>
)

export default NoticeMessageContainer
